<div class="container">
  <section
    *ngIf="addressRichHeading"
    [innerHTML]="addressRichHeading"
  ></section>
  <form
    class="justify-content-center"
    [formGroup]="addressLookupForm"
    name="address-lookup-form"
    id="address-lookup-form"
    novalidate
    data-automation-id="address-lookup-form"
  >
    <div class="row mb-4" *ngIf="showCustomerType">
      <div class="col">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            [value]="CUSTOMER_TYPE_VALUE_HOME"
            formControlName="customerType"
            name="customerType"
            id="radioHome"
            data-automation-id="home-radio-button"
          />
          <label
            class="form-check-label"
            for="radioHome"
            data-automation-id="home-label"
          >
            For Home
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            [value]="CUSTOMER_TYPE_VALUE_BUSINESS"
            formControlName="customerType"
            name="customerType"
            id="radioBusiness"
            data-automation-id="business-radio-button"
          />
          <label
            class="form-check-label"
            for="radioBusiness"
            data-automation-id="business-label"
          >
            For Business
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
        <div class="row">
          <div
            [ngClass]="{
              'col-md-12': !showBusiness,
              'col-md-6': showBusiness
            }"
            class="input-wrapper"
          >
            <div class="form-floating">
              <input
                id="typeahead-http"
                type="text"
                class="form-control"
                name="addressLookup"
                formControlName="address"
                [class.is-invalid]="searchFailed"
                (selectItem)="onSelectedAddress($event)"
                [ngbTypeahead]="search"
                [resultFormatter]="inputFormatter"
                [inputFormatter]="inputFormatter"
                [editable]="false"
                [placeholder]="beforeFormText"
                (keyup.enter)="updateAddressInput(true)"
                #typeAheadInstance="ngbTypeahead"
                #typeAheadElement
                data-automation-id="address-typeahead-input"
              />
              <label
                for="addressLookup"
                class="digital-platform-input-label base"
                >{{ beforeFormText }}</label
              >
            </div>

            <button
              *ngIf="typeAheadElement?.value"
              class="close-icon"
              type="button"
              (click)="clearAddress()"
              data-automation-id="address-typeahead-x-button"
            ></button>
          </div>
          <ng-container *ngIf="showBusiness">
            <div class="col-md-6">
              <digital-platform-dropdown
                variant="base"
                placeholder="Select Business Type"
                name="businessType"
                formControlName="businessType"
                data-automation-id="business-type"
                [options]="businessDropdownItems"
              >
              </digital-platform-dropdown>
            </div>
          </ng-container>
        </div>

        <div class="search-messages d-block">
          <small *ngIf="searching" class="invalid-container text-muted"
            >Searching...</small
          >

          <div *ngIf="searchFailed && !searching" class="invalid-container">
            <img
              class="invalid-icon"
              alt="invalid"
              src="/assets/icons/triangle-exclamation.svg"
            />
            <small
              class="error-message"
              data-automation-id="api-fail-error-message"
              >We are currently experiencing technical difficulties, please try
              again in a few minutes or contact Customer Services to speak to a
              representative.</small
            >
          </div>

          <div
            *ngIf="
              (noResults ||
                (!selectedAddressRaw && !addressLookupForm.pristine)) &&
              !searching &&
              !searchFailed
            "
            class="invalid-container"
          >
            <img
              class="invalid-icon"
              alt="invalid"
              src="/assets/icons/triangle-exclamation.svg"
            />
            <small
              class="error-message"
              data-automation-id="invalid-address-error-message"
              >Please enter a valid address</small
            >
          </div>
        </div>
      </div>

      <div class="col-md-2 d-flex align-items-center">
        <digital-platform-cta-button
          *ngIf="ctaButton && ctaButton.length > 0"
          linkClass="px-8"
          [analyticsLinkText]="ctaButton[0].analyticsLinkText"
          [isButtonDisabled]="isFormInvalid()"
          [chevron]="ctaButton[0].chevron"
          [ctaPosition]="ctaButton[0].ctaPosition"
          [ctaSize]="ctaButton[0].ctaSize"
          [ctaStyle]="ctaButton[0].ctaStyle"
          [ctaWidth]="ctaButton[0].ctaWidth"
          [fontAwesomeIconClass]="ctaButton[0].fontAwesomeIconClass"
          [marginBottomClass]="ctaButton[0].marginBottomClass"
          [marginTopClass]="ctaButton[0].marginTopClass"
          [url]="ctaButton[0].url"
          [visibility]="ctaButton[0].visibility"
          (click)="updateAddressInput(true)"
          data-automation-id="address-typeahead-submit-button"
        ></digital-platform-cta-button>
      </div>
    </div>
  </form>
</div>
